import React from 'react';
import icalendar from 'icalendar';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { LOCALES_OBJ } from 'constants/base';

const ScheduleDates = ({ item }) => {
  const [t, i18n] = useTranslation();

  const selectedLanguage = i18n.language;

  if (item) {
    let startDate = '';
    let endDate = '';

    if (item.schedule) {
      const scheduleProperties = icalendar.parse_calendar(item.schedule)
        .properties;
      startDate = scheduleProperties.START_DATE[0].value;
      endDate = scheduleProperties.END_DATE[0].value;
    } else {
      startDate = item.fromDate;
      endDate = item.toDate;
    }

    const startDateFormatted = moment(startDate, 'YYYY-MM-DD')
      .locale(LOCALES_OBJ[selectedLanguage])
      .format('MMM D, YYYY');
    const endDateFormatted = endDate
      ? moment(endDate, 'YYYY-MM-DD')
          .locale(LOCALES_OBJ[selectedLanguage])
          .format('MMM D, YYYY')
      : endDate;

    if (!endDate || endDate === 'None')
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {startDateFormatted} <span style={{ marginLeft: '32px' }}>—</span>
        </div>
      );

    return `${startDateFormatted} - ${endDateFormatted}`;
  }

  return null;
};

export default ScheduleDates;
